import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type PromocodeGroupListResponseBody as SchemaPromocodeGroupListResponseBody } from '../schemas/PromocodeGroupListResponseBody';
import { type PromocodeGroupType as SchemaPromocodeGroupType } from '../schemas/PromocodeGroupType';
import { type PromocodeListSortBy as SchemaPromocodeListSortBy } from '../schemas/PromocodeListSortBy';
import { type PromocodeListSortDirection as SchemaPromocodeListSortDirection } from '../schemas/PromocodeListSortDirection';
import { type PromocodeStatus as SchemaPromocodeStatus } from '../schemas/PromocodeStatus';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @description Возвращает список групп промокодов с пагинацией
 * @tags PromocodeGroups
 * @summary Получение списка групп промокодов
 */
export const PromocodeGroupListContentType = '' as const;
export type PromocodeGroupListRequest = void;
export type PromocodeGroupListResponses = LinkCommonErrorResponses & {
    /**
     * @description Успешная операция
     */
    '200': {
        'application/json': SchemaPromocodeGroupListResponseBody;
    };
};
export type PromocodeGroupListResponseSuccess = PromocodeGroupListResponses['200']['application/json'];
export type PromocodeGroupListSearchParams = {
    sort_by?: SchemaPromocodeListSortBy;
    sort_direction?: SchemaPromocodeListSortDirection;
    status?: SchemaPromocodeStatus;
    group_type?: SchemaPromocodeGroupType;
    page?: number;
    per_page?: number;
};
export type PromocodeGroupListPathParameters = undefined;
export const PromocodeGroupListUrl = '/promocode_groups' as const;
export const PromocodeGroupListMethod = 'GET' as const;
export const getPromocodeGroupListUrl = (_params?: PromocodeGroupListPathParameters) => PromocodeGroupListUrl;
